module.exports = __webpack_public_path__ + "static/media/email-icon-hover.8acbda37.svg";